import styled from 'styled-components'

export const TutorialWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
